import { FC } from "react";
import dayjs from "dayjs";
import Button from "@components/new/Button/Button";
import { IconInfoStokes } from "@icons";
import {
    SSB_GENERATED_ON_DATE_FORMAT,
    SSB_GENERATED_ON_PREFIX,
    SSB_INFO_ARIA,
    SSB_INFO_INTRO,
    SSB_INFO_LEVELS,
} from "../Strategy.constants";
import "./StrategyTitleInfo.styles.scss";

interface StrategyTitleInfoProps {
    createdAt: string | null;
}

const StrategyTitleInfo: FC<StrategyTitleInfoProps> = ({ createdAt }) => (
    <div className="StrategyTitleInfo">
        <Button
            className="StrategyTitleInfo__info-button"
            ariaLabel={SSB_INFO_ARIA}
            tooltipText={
                <div className="StrategyTitleInfo__tooltip">
                    {SSB_INFO_INTRO}
                    <ul>
                        {SSB_INFO_LEVELS.map(level => <li key={level}>{level}</li>)}
                    </ul>
                </div>
            }
            tooltipPosition={["right", "below"]}
        >
            <IconInfoStokes />
        </Button>
        {createdAt && (
            <span className="StrategyTitleInfo__generated-on">
                {SSB_GENERATED_ON_PREFIX} {dayjs(createdAt).format(SSB_GENERATED_ON_DATE_FORMAT)}
            </span>
        )}
    </div>
);

export default StrategyTitleInfo;
